// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'// axios IE support
import 'babel-polyfill'// es6 IE support
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuelidate from 'vuelidate'
import { store } from './store/store'
import Paginate from 'vuejs-paginate'

Vue.component('paginate', Paginate)
Vue.use(Vuelidate)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js